export type $Object = { [key: string]: unknown }

export const withValues = <T extends Record<string, unknown>>(obj: T): T => {
  const result = {} as T

  Object.keys(obj ?? {}).forEach((key) => {
    const value = obj[key]
    const isEmptyArray = Array.isArray(value) && value.length === 0
    const isEmptyObject =
      typeof value === 'object' &&
      value !== null &&
      !Array.isArray(value) &&
      Object.keys(value).length === 0

    if (
      value === null ||
      value === undefined ||
      value === '' ||
      isEmptyArray ||
      isEmptyObject
    ) {
      return
    }

    result[key as keyof T] = value as T[keyof T]
  })

  return result
}

export function getOnlyExistingKeys<T extends $Object>(
  obj1: $Object,
  obj2: $Object
): T {
  const obj1Keys = Object.keys(obj1)

  return Object.keys(obj2).reduce(
    (acc, i) => ({ ...acc, ...(obj1Keys.includes(i) ? { [i]: obj2[i] } : {}) }),
    {} as T
  )
}

export const omitKeys = <T extends object, K extends Extract<keyof T, string>>(
  obj: T,
  keys: K[]
): Omit<T, K> => {
  const updatedObj = { ...obj }

  for (const key of keys) {
    delete updatedObj[key]
  }

  return updatedObj
}
